/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowMergeRight = createReactComponent(
  "arrow-merge-right",
  "IconArrowMergeRight",
  [
    ["path", { d: "M16 8l-4 -4l-4 4", key: "svg-0" }],
    ["path", { d: "M12 20v-16", key: "svg-1" }],
    ["path", { d: "M18 18c-4 -1.333 -6 -4.667 -6 -10", key: "svg-2" }]
  ]
);

export { IconArrowMergeRight as default };
//# sourceMappingURL=IconArrowMergeRight.js.map
